module.exports = __webpack_public_path__ + "assets/slow_area.d0a6af8e.svg";